import React from 'react'
import styles from './PlannerOnboardingModal.scss'
import blueTheme from 'common/styleguide/ModalOverlay/blueHeaderModalTheme.scss'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {CTA} from 'common/styleguide/CTA'
import {Map} from 'immutable'
import {introText} from 'lib/styleguide/base.scss'
import fetchJSON from 'lib/fetchJSON'
import querystring from 'querystring'
import cx from 'classnames'

const tips = [
  {
    title: 'Follow Roads',
    text: 'Use the <strong>Follow Roads</strong> tool to plan a trip by clicking along your intended path using <strong>Control Points</strong>',
    gif: '/images/planner-onboarding/follow-roads.gif'
  },
  {
    title: 'Avoid Intersections',
    text: 'Avoid clicking in intersections. This can cause your <strong>cuesheet</strong> to have errors. Always click before or after the intersection along the road you wish to take.',
    gif: '/images/planner-onboarding/clicked-intersection-warning.gif'
  },
  {
    title: 'Control Points',
    text: '<strong>Control Points</strong> can fence in your route, use these to maintain your route’s integrity while dragging and dropping to edit your route.',
    gif: '/images/planner-onboarding/control-points.gif'
  },
  {
    title: 'Map Types',
    text: 'Switch maps to take advantage of different routing engines and different views. Get stuck when routing? Use this tool to get around roadblocks. ',
    gif: '/images/planner-onboarding/map-types.gif'
  },
  {
    title: 'Custom Cues',
    text: 'You can edit your cues and add <strong>Custom Cues</strong> to personalize your <strong>cuesheet</strong> and route.',
    gif: '/images/planner-onboarding/custom-cue.gif'
  },
  {
    title: 'Draw Lines',
    text: 'Stuck or can’t route on an unmarked trail? <strong>Draw Lines</strong> can get you around unroutable areas.',
    gif: '/images/planner-onboarding/draw-lines.gif'
  }
]

export class PlannerOnboardingModal extends React.PureComponent {
  constructor (props) {
    super(props)

    const preferences = Map((window.rwgps && window.rwgps.config && window.rwgps.config.currentUser && window.rwgps.config.currentUser.preferences) || {})

    const params = querystring.parse(window.location.search.substring(1))

    this.state = {
      dismissed: preferences.get('planner-onboarding-dismissed', false) && !params.onboarding,
      activeTip: 0
    }
  }

  onRequestClose = (event) => {
    fetchJSON('/set_preference.json', {key: 'planner-onboarding-dismissed', value: true})
    this.setState({dismissed: true})
  }

  nextClicked = (event) => {
    this.setState({ activeTip: (this.state.activeTip + 1) % tips.length })
  }

  goToIndex = (index) => {
    return () => this.setState({activeTip: index})
  }

  render () {
    if (this.state.dismissed) {
      return null
    }

    const tip = tips[this.state.activeTip]

    const button = (this.state.activeTip >= tips.length - 1)
      ? (
        <div>
          <CTA link inline margins={false} onClick={this.goToIndex(0)}>Show me again</CTA>
          <CTA inline margins={false} onClick={this.onRequestClose}>Done</CTA>
        </div>
      ) : (
        <CTA margins={false} inline onClick={this.nextClicked}>Next</CTA>
      )

    const pips = tips.map((tip, index) => (
      <span className={cx(styles.pip, this.state.activeTip === index && styles.current)} onClick={this.goToIndex(index)} key={tip.gif} />
    ))

    return (
      <ModalOverlay
        className={styles.PlannerOnboardingModal}
        maxWidth='800px'
        shouldCloseOnOverlayClick
        title='Welcome to the Route Planner'
        onRequestClose={this.onRequestClose}
        footer={<div className={styles.ctaContainer}>{button}</div>}
        theme={blueTheme}>
        <div className={styles.TipsCarousel}>
          <div className={styles.imgContainer}>
            <img src={tip.gif} />
          </div>
          <p className={styles.title}>{tip.title}</p>
          <p className={introText} dangerouslySetInnerHTML={{__html: tip.text}} />
          <div>{pips}</div>
        </div>
      </ModalOverlay>
    )
  }
}
